import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import FeatureDrawer from "../helpers/FeatureDrawer";
import MapElement from "./MapElement";
import FeatureStyle from '../helpers/FeatureStyles';
import WebGLPointsLayer from 'ol/layer/WebGLPoints';
import colors from 'dxf/src/util/colors'

export default class MapDxfLayer extends MapElement {
    constructor(map, name, mapElementSettings, parent, projection, data) {
        super(map, name, mapElementSettings, parent);
        this.name = name;
        this.parentId = parent.id;
        this.features = data;
        this.projection = projection;

        this.noKey = true;
        this.drawStyle = null;

        this.style = null;
    }

    drawLayer(drawStyle) {
        this.style = null
        this.drawStyle = drawStyle;

        switch (this.drawStyle) {
            case "roadprofiler":
                this.style = FeatureStyle.customProfilerStyle
                break;
            case "vector":
                if (this.parentId == "STEERINGLINES") {
                    this.style = (ft, res) => { return FeatureStyle.curstomVectorStyle(ft, res, this.mapModel.dark, false); }
                } else {
                    this.style = (ft, res) => { return FeatureStyle.curstomEnvironmentStyle(ft, res, this.mapModel.dark, false); }
                }
                break;
            case "spraypoints":
                this.style = (ft, res) => { return FeatureStyle.customSprayPointsStyle(ft, res, this.mapModel.dark, false); }
                break;
            case "spraypointsEnvironment":
                this.style = (ft, res) => { return FeatureStyle.customSprayPointEnvironmentStyle(ft, res, this.mapModel.dark, false); }
                break;
            default:
                this.style = (ft, res) => { return FeatureStyle.customLineStyle(ft, res, this.mapModel.dark, false); }
                break;
        }


        var source = new VectorSource();
        this.layer = new VectorLayer({
            parentId: this.parentId,
            source: source,
            style: this.style
        });

        if (this.drawStyle == 'vector') {
            var counter = 0;
            for (var item of this.features) {
                if (item.get('dxfData').type == 'POINT') counter++;
                if (counter >= 5) {
                    var colorNumber = item.get('colorNumber')

                    if (this.mapModel.dark && (colorNumber == 0 || colorNumber == 18)) { // make black and darkred(dxflib issue?) white
                        colorNumber = 7;
                    }
                    if (!this.mapModel.dark && (colorNumber == 7)) { // make white black
                        colorNumber = 0;
                    }

                    this.layer = new WebGLPointsLayer({
                        source: source,
                        style: {
                            symbol: {
                                symbolType: 'circle',
                                size: 7,
                                color: colors[colorNumber], // color of 5th point entity
                                opacity: 1
                            }
                        },
                    });
                    break;
                }
            }
        }

        source.addFeatures(this.features);

        if (this.parent && this.parent.layer) {
            this.parent.layer.getLayers().push(this.layer);
        }

        if (!this.mapElementSettings.defaultOn) {
            this.hide();
        }
    }

    colorSelectedLayer(selected) {
        if (selected) {
            //color green
            this.layer.setStyle((ft, res) => FeatureStyle.customSelectedLayerLineStyle(ft, res, this.mapModel.dark, false));
        } else {
            //change back
            this.layer.setStyle(this.style)
        }
    }
}